import React from 'react';

const Wysiwyg = ({ content }) => {
  return (
    <div className="max-w-[792px] prose mb-[48px] md:mb-[73px] mx-auto" dangerouslySetInnerHTML={{ __html: content }} />
  );
};

export default Wysiwyg;
